import React, { useLayoutEffect, useRef, useState } from 'react';
import { useHandleClickOutside } from 'hooks';

import { Button } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import { action } from 'lib/actionHelpers';
import { icons } from 'images';
import datePickerFilterStaticDateRanges from 'screens/reports/lib/datePickerFilterStaticDateRanges.js';
import { useSelector } from 'react-redux';
import { subDays } from 'date-fns';

const buildAndSetDateCookie = (key, dateVal) => {
  var date = new Date();
  date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
  var expires = 'expires=' + date.toGMTString();
  const cookieString = key + '=' + String(dateVal) + '; ' + 'path=/;' + expires;
  document.cookie = cookieString;
};

const getDateCookies = (key) => {
  const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
  if (match) return match[2];
};

export const defaultDatePickerFilterValue = {
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  key: 'selection',
};

const DatePickerFilterItem = ({ item }) => {
  const cookieStartDate = getDateCookies('reportDatesStartDate');
  const cookieEndDate = getDateCookies('reportDatesEndDate');

  const filterValue = useSelector((state) => state.ui.filters[item.id || item.type]) || defaultDatePickerFilterValue;
  const value = cookieStartDate && cookieEndDate ? { startDate: new Date(cookieStartDate), endDate: new Date(cookieEndDate) } : { ...filterValue, startDate: new Date(filterValue.startDate), endDate: new Date(filterValue.endDate) };
  getDateCookies();
  const [isVisible, setIsVisible] = useState(false);
  const wrapperRef = useRef(null);

  useHandleClickOutside(wrapperRef, () => {
    setIsVisible((state) => (state ? false : state));
  });

  useLayoutEffect(() => {
    const inputEl = document.getElementsByClassName('rdrDateInput');
    const staticRanges = document.getElementsByClassName('rdrStaticRange');
    for (let range of staticRanges) {
      range.addEventListener('click', () => setIsVisible(false), false);
    }
    const leftInput = inputEl[0];
    const rightInput = inputEl[1];
    const leftChild = (leftInput || {}).firstChild;
    const rightChild = (rightInput || {}).firstChild;
    if (leftChild && rightChild) {
      leftChild.addEventListener('click', () => setIsVisible(true), false);
      rightChild.addEventListener('click', () => setIsVisible(true), false);
    }
    return () => {
      if (leftChild && rightChild) {
        leftChild.removeEventListener('click', () => setIsVisible(true));
        rightChild.removeEventListener('click', () => setIsVisible(true));
        for (let range of staticRanges) {
          range.removeEventListener('click', () => setIsVisible(false));
        }
      }
    };
  }, []);

  useLayoutEffect(() => {
    const inputs = [...document.getElementsByClassName('rdrDateInput')];
    if (!isVisible) {
      inputs.forEach((n) => n.classList.remove('rdrDateDisplayItemActive'));
    } else if (inputs.filter((n) => n.classList.contains('rdrDateDisplayItemActive')).length < 1) {
      inputs[0].classList.add('rdrDateDisplayItemActive');
    }
  }, [isVisible]);

  const handleDatePickerChange = (data) => {
    const startDate = (data.selection || {}).startDate ? (data.selection || {}).startDate : (data.range1 || {}).startDate;
    const endDate = (data.selection || {}).endDate ? (data.selection || {}).endDate : (data.range1 || {}).endDate;
    const aggregate = (data.selection || {}).defaultAggregatorRange ? (data.selection || {}).defaultAggregatorRange : (data.range1 || {}).defaultAggregatorRange;
    const payload = {
      [item.id || item.type]: {
        key: 'selection',
        startDate,
        endDate,
        aggregate,
      },
    };
    if (aggregate && item.aggregateId) {
      payload[item.aggregateId] = aggregate;
    }
    buildAndSetDateCookie('reportDatesStartDate', startDate);
    buildAndSetDateCookie('reportDatesEndDate', endDate);
    action('uiPatchFilters', payload);
    if (item.onSubmit && aggregate) {
      item.onSubmit();
    }
  };

  const handleSubmitClick = () => {
    if (item.onSubmit) {
      item.onSubmit();
    }
    setIsVisible(false);
  };

  return (
    <div className={`date-range-wrapper ${isVisible ? 'visible' : ''}`} ref={wrapperRef}>
      <DateRangePicker showSelectionPreview={true} moveRangeOnFirstSelection={true} months={1} onChange={handleDatePickerChange} className={isVisible ? 'visible' : null} staticRanges={datePickerFilterStaticDateRanges} ranges={[value]} />
      <div className={`button-tray ${isVisible && 'visible'}`}>
        <Button onClick={handleSubmitClick}>Submit</Button>
        <Button onClick={(e) => setIsVisible(false)}>Close</Button>
      </div>
      <div className={`design-background ${isVisible ? 'visible' : null}`}>
        <img alt="calendar" src={icons['icon-calendar']} />
      </div>
      <span className="date-dash" />
    </div>
  );
};

export default DatePickerFilterItem;
